export enum Gender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  Private = 'private',
  None = 'none',
}

export const GENDER = Object.values(Gender);
